import { ElLoading } from 'element-plus/lib/components'
import { App } from 'vue'
import { formatToDateTime } from './date'
import feedback from './feedback'
import { validForm } from './validate'

// 获取当前屏幕可见区域宽度
export const offsetWid = document.documentElement.clientWidth

// 获取当前屏幕可见区域高度
export const offsetHeight = document.documentElement.clientHeight

export const _height = 145
export const _image = 'data:image/jpegbase64,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'

// 获取当前网址后面的参数
export function GetParams(Name: string) {
  // 获取url值
  const ref = window.location.href
  let args = ref.split('?')
  let retral = ''
  if (args[0] === ref) /* 参数为空 */ {
    return retral
  }
  let str = args[1]
  args = str.split('&')
  for (let i = 0; i < args.length; i++) {
    str = args[i]
    const arg = str.split('=')
    if (arg.length <= 1) continue
    if (arg[0] === Name) retral = arg[1]
  }
  return retral
}

// 判断网址是否在微信下打开
export function isWeiXin(): boolean {
  const ua = window.navigator.userAgent.toLowerCase()
  const match = ua.match(/MicroMessenger/i)
  if (match === null) {
    return false
  }
  if (match.includes('micromessenger')) {
    return true
  }
  return false
}

/**
 * @description: 获取设备的型号
 * @param {string} userAgent window.userAgent
 * @return {string} mobile/ipad/pc
 */
export function getDevice(userAgent: string): string {
  return /(Android|iPhone|iPod|iOS|SymbianOS|Windows Phone)/ig.test(userAgent) ? 'mobile' : /iPad/ig.test(userAgent) ? 'ipad' : 'pc'
}

/**
 * @description: 判断屏幕最大宽度不超过
 * @param {number} width 要判断的最大宽度
 * @return {boolean} 屏幕宽度是否小于等于 width
 */
export function screenMaxIs(width: number): boolean {
  return window.screen.width <= width
}

// 模拟a标签下载文件
export function downloadFile(url: string, fileName: string) {
  const loading = ElLoading.service({
    lock: true,
    text: '下载中...',
    background: 'rgba(0, 0, 0, 0.7)'
  })
  url = url + '?t=' + new Date().getTime()
  // fetch(url).then((res) => {
  //   res.blob().then((blob) => {
  //     const blobUrl = window.URL.createObjectURL(blob)
  //     const a = document.createElement('a')
  //     a.style.display = 'none'
  //     document.body.appendChild(a)
  //     a.href = blobUrl
  //     a.download = fileName
  //     a.click()
  //     document.body.removeChild(a)
  //     window.URL.revokeObjectURL(blobUrl)
  //     loading.close()
  //   })
  // }).catch(err => {
  //   loading.close()
  //   console.error(err)
  // })
  const image = new Image()
  // 解决跨域 Canvas 污染问题
  image.setAttribute('crossOrigin', 'anonymous')
  image.onload = () => {
    const canvas = document.createElement('canvas')
    canvas.width = image.width
    canvas.height = image.height
    const context = canvas.getContext('2d') as CanvasRenderingContext2D
    context.drawImage(image, 0, 0, image.width, image.height)
    canvas.toBlob((blob) => {
      const url = URL.createObjectURL(blob as Blob)
      const a = document.createElement('a')
      a.download = fileName
      a.href = url
      a.click()
      a.remove()
      URL.revokeObjectURL(url)
      loading.close()
    })
  }
  image.src = url
}

/** IP地址转换为星号 */
export function formatIPAddress(str: string) {
  if (typeof str !== 'string') {
    return
  }
  const arr: string[] = str.split('.') // 首先，由split将ip以.分割数组
  function formatName(str: string) {
    return new Array(str.length + 1).join('*')
  }

  return formatName(arr[0]) + '.' + formatName(arr[1]) + '.' + arr[2] + '.' + arr[3]
}

// 时间戳转多少分钟之前
export function getDateDiff(dateTimeStamp: string) {
  // 时间字符串转时间戳
  const timestamp = new Date(dateTimeStamp).getTime()
  const minute = 1000 * 60
  const hour = minute * 60
  const day = hour * 24
  const month = day * 30
  const year = day * 365
  const now = new Date().getTime()
  const diffValue = now - timestamp
  let result
  if (diffValue < 0) {
    return
  }
  const yearC = diffValue / year
  const monthC = diffValue / month
  const weekC = diffValue / (7 * day)
  const dayC = diffValue / day
  const hourC = diffValue / hour
  const minC = diffValue / minute
  if (yearC >= 1) {
    result = '' + parseInt(yearC as unknown as string) + '年前'
  } else if (monthC >= 1) {
    result = '' + parseInt(monthC as unknown as string) + '月前'
  } else if (weekC >= 1) {
    result = '' + parseInt(weekC as unknown as string) + '周前'
  } else if (dayC >= 1) {
    result = '' + parseInt(dayC as unknown as string) + '天前'
  } else if (hourC >= 1) {
    result = '' + parseInt(hourC as unknown as string) + '小时前'
  } else if (minC >= 1) {
    result = '' + parseInt(minC as unknown as string) + '分钟前'
  } else {
    result = '刚刚'
  }
  return result
}

// 切割文件名
export const splitFileName = (file: string) => {
  const fileArr = file.split('.')
  const suffix = fileArr[fileArr.length - 1]
  const prefix = file.split('.' + suffix)[0]
  return {
    prefix,
    suffix
  }
}

export default {
  install: (app: App) => {
    app.config.globalProperties.$feedback = feedback
    app.config.globalProperties.$validForm = validForm
    app.config.globalProperties.$formatToDateTime = formatToDateTime
  }
}

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $feedback: typeof feedback
    $validForm: typeof validForm
    $formatToDateTime: typeof formatToDateTime
  }
}
